import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-ui-image-picker',
  templateUrl: './ui-image-picker.component.html',
  styleUrls: ['./ui-image-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiImagePickerComponent {
  @Input() previewUrl: string | null = null;
  @Input() view: 'circle' | 'button' = 'circle';
  public _progress = 0;
  @Input() set progress(_: number) {
    this._progress = _;
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }
  @Output() imageLoaded = new EventEmitter<File>();

  constructor(private cdr: ChangeDetectorRef) {}
  public onFileDropped(fileList: FileList) {
    if (!fileList) {
      return;
    }

    if (fileList.length === 0) {
      console.error('no file selected');
      return;
    }

    if (fileList.length > 1) {
      console.error('only single file allowed');
      return;
    }

    if (!fileList[0].type.startsWith('image/')) {
      console.error('only images allowed');
      return;
    }

    this.loadImage(fileList[0]);
  }

  public fileBrowseHandler(event: any) {
    const fileList = event.target.files;

    if (!fileList) {
      return;
    }
    if (fileList.length === 0) {
      console.error('no file selected');
      return;
    }

    if (fileList.length > 1) {
      console.error('only single file allowed');
      return;
    }

    if (!fileList[0].type.startsWith('image/')) {
      console.error('only images allowed');
      return;
    }

    this.loadImage(fileList[0]);
  }

  public loadImage(file: File) {
    if (!file) {
      return;
    }

    this.previewUrl = URL.createObjectURL(file);
    this.imageLoaded.emit(file);
  }

  public clearImage() {
    this.previewUrl = null;
  }
}
